import { CopyStudentsEmailSectionCombinedProps } from './types';

const usePresenter = (props: CopyStudentsEmailSectionCombinedProps): CopyStudentsEmailSectionCombinedProps => {
  return props;
};

export default usePresenter;
